import * as React from "react"
import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import IconButton from "@mui/material/IconButton"
import {
    DataGrid,
} from "@mui/x-data-grid"
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import { ceil } from "../../Utils";
import { AXIOS_API_INSTANCE } from "../../Constants"
import { send_authorized_request } from "../../Constants/cognito"
import axios from "axios"

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import { SimpleCustomToolbar } from "../CustomToolbar"
import onFilterChange from "../../Utils/OnFilterChange"
import { Box, InputAdornment, TextField, debounce } from "@mui/material"
import RentalItem from "./RentalItem";
import { useTrackedLocation } from "../UserState"
import RentalItemRow from "./RentalItemRow"
import { LoadingBackdropIndeterminate } from "../LoadingBackdrop"
import { useCookies } from "react-cookie"
dayjs.extend(utc);
dayjs.extend(ceil);

const rentalType_columns = [
    {
        field: "name",
        headerName: "Type",
        flex: true,
        editable: false,
    },
    {
        field: "rental_category:name",
        headerName: "Category",
        flex: true,
        editable: false,
        sortable: false,
        filterable: false,
        valueGetter: (params) => {
            return `${params.row.rental_category.name || ''}`;
        },
    },
    // {
    //     field: "rental_items:count",
    //     headerName: "# Items",
    //     flex: true,
    //     editable: false,
    //     sortable: false,
    //     filterable: false,
    //     valueGetter: (params) => {
    //         return `${params.row.rental_items || ''}`;
    //     },
    // },
]

export default function RentalItems(props) {
    const [selectedLocation,] = useTrackedLocation(); // REMOVED setSelectedLocation to make linter happy
    const [cookies, setCookie] = useCookies(["pagination"])
    const [rentalItemsSorting,] = React.useState({ field: 'id', sort: 'asc' })
    const [rentalItemsFiltering,] = React.useState({})
    const [rentalTypeSorting, setRentalTypeSorting] = React.useState({ field: 'id', sort: 'asc' })
    const [rentalTypeFiltering, setRentalTypeFiltering] = React.useState({})
    const [rentalTypeSearch, setRentalTypeSearch] = React.useState('')
    const [selectedRentalType, setSelectedRentalType] = React.useState({})
    const [selectedRentalItem, setSelectedRentalItem] = React.useState({})
    const [creatingNewRentalItem, setCreatingNewRentalItem] = React.useState(false)
    const [editingRentalItem, setEditingRentalItem] = React.useState(false)
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: cookies.pagination?.rentalitems_types_pageSize || 10,
        page: 0,
    });
    const [rentalTypeRowData, setRentalTypeRowData] = React.useState({ rows: [], total_count: 0 })
    const [rentalItemsRowData, setRentalItemsRowData] = React.useState(undefined)
    const [isLoading, setIsLoading] = React.useState(true)

    const rentalTypeRowClick = (data, event, c) => {
        if (!isLoading) {
            setSelectedRentalType(data.row)
        }
    }
    const selectRentalItem = (item) => {
        setEditingRentalItem(false)
        setSelectedRentalItem(item)
    }
    const selectRentalItemEdit = (item) => {
        setEditingRentalItem(true)
        setSelectedRentalItem(item)
    }

    const backButton = () => {
        if (!isLoading) {
            // Viewing a specific rental item or creating a new one
            if ((rentalItemsRowData && selectedRentalItem.id !== undefined) || creatingNewRentalItem) {
                setSelectedRentalItem({})
                setCreatingNewRentalItem(false)
            }
            // Viewing specific rental type
            else {
                setSelectedRentalType({})
                setRentalItemsRowData(undefined)
            }
        }
    }
    const updateRentalTypeSearch = (event) => {
        setRentalTypeSearch(event.target.value.trim())
        if (event.target.value.trim() !== rentalTypeSearch) {
            debouncedGetRentalType(rentalTypeSorting.field, rentalTypeSorting.sort, rentalTypeFiltering, event.target.value.trim())
        }
    }

    const createRentalItemClick = (params) => {
        setCreatingNewRentalItem(true)
        setSelectedRentalItem({
            id: -1,
            location: selectedLocation,
            location_id: selectedLocation.id,
            rental_type: selectedRentalType,
            rental_type_id: selectedRentalType.id,
            total_quantity: 1,
            purchase_date: dayjs.utc()
        })
    }

    const newlyCreatedCallback = (newRentalItem) => {
        setCreatingNewRentalItem(false)
        setSelectedRentalItem(newRentalItem)
    }

    const setMyPaginationModel = (model) => {
        setCookie(
            "pagination",
            { ...cookies.pagination, rentalitems_types_pageSize: model.pageSize },
            { path: "/" }
        )
        setPaginationModel(model)
    }

    const getRentalType = (sortField, sortDirection, filterVar, rentalTypeSearch) => {
        setIsLoading(true)
        let my_filters = Object.assign({}, filterVar);
        if (rentalTypeSearch.length > 0) {
            my_filters['or'] = []
            my_filters['or'].push({ 'rental_category:name.ilike': rentalTypeSearch })
            my_filters['or'].push({ 'name.ilike': rentalTypeSearch })
        }
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentaltype", {
                        params: {
                            page_num: paginationModel.page,
                            page_size: paginationModel.pageSize,
                            order_by: sortField,
                            order_by_direction: sortDirection,
                            filters: JSON.stringify(my_filters),
                        },
                    }),
                ])
                .then(
                    axios.spread((customer) => {
                        console.log(customer)
                        setRentalTypeRowData({
                            rows: customer.data.data,
                            total_count: customer.data.total_count,
                        })
                        setIsLoading(false)
                    })
                )
        )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedGetRentalType = React.useMemo(() => debounce((sortField, sortDirection, filterVar, rentalTypeSearch) => getRentalType(sortField, sortDirection, filterVar, rentalTypeSearch), 400), []);

    const getRentalItems = (sortField, sortDirection, filterVar) => {
        setIsLoading(true)
        let my_filters = Object.assign({}, filterVar);
        if (selectedLocation.id !== "all") {
            my_filters['location_id.eq'] = selectedLocation.id
        }
        my_filters['rental_type_id.eq'] = selectedRentalType.id
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentalitems", {
                        params: {
                            // page_num: itemsPaginationModel.page,
                            // page_size: itemsPaginationModel.pageSize,
                            order_by: sortField,
                            order_by_direction: sortDirection,
                            filters: JSON.stringify(my_filters),
                        },
                    }),
                ])
                .then(
                    axios.spread((rentalitems) => {
                        console.log(rentalitems)
                        setRentalItemsRowData({
                            rows: rentalitems.data.data.map((item) => { return { ...item, purchase_date: dayjs(item.purchase_date) } }),
                            total_count: rentalitems.data.total_count,
                        })
                        setIsLoading(false)
                    })
                )
        )
    }

    React.useEffect(() => {
        getRentalType(rentalTypeSorting.field, rentalTypeSorting.sort, rentalTypeFiltering, rentalTypeSearch)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rentalTypeSorting, rentalTypeFiltering])

    React.useEffect(() => {
        if (selectedRentalType.id !== undefined && selectedRentalItem?.id === undefined) {
            getRentalItems(rentalItemsSorting.field, rentalItemsSorting.sort, rentalItemsFiltering)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLocation, selectedRentalType, selectedRentalItem, rentalItemsSorting, rentalItemsFiltering])

    return (
        (<React.Fragment>
            <Grid container space={1}>
                <Grid xs>
                    <Grid container space={1} alignItems="center" justifyContent={"flex-end"}>
                        <Grid xs>
                            {!rentalItemsRowData &&
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="reservesearch"
                                    label="Search type or category"
                                    type="text"
                                    variant="filled"
                                    disabled={isLoading}
                                    value={rentalTypeSearch}
                                    onChange={updateRentalTypeSearch}
                                    slotProps={{
                                        input: {
                                            inputProps: { min: 1 },
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    {<SearchIcon />}
                                                </InputAdornment>
                                            ),
                                        }
                                    }}
                                />
                            }
                            {rentalItemsRowData && selectedRentalItem.id === undefined && !creatingNewRentalItem &&
                                <Box>
                                    <Grid container>
                                        <Grid xs="auto">
                                            <Box onClick={() => backButton()}>
                                                <IconButton color="inherit">
                                                    <ArrowBackIcon />
                                                </IconButton>
                                            </Box>
                                        </Grid>
                                        <Grid item>
                                            <span><b>{selectedRentalType.name} ({selectedRentalType.rental_category.name})</b></span>
                                        </Grid>
                                    </Grid>
                                </Box>
                            }
                        </Grid>
                        <Grid xs="auto">

                        </Grid>
                        {rentalItemsRowData && selectedRentalItem.id === undefined && !creatingNewRentalItem &&
                            <Grid xs="auto" sx={{ pr: 2, pl: 1 }}>
                                <Button variant="contained" onClick={createRentalItemClick}><AddCircleSharpIcon />  Add Item</Button>
                            </Grid>
                        }
                    </Grid>
                    {!rentalItemsRowData && selectedRentalItem.id === undefined && !creatingNewRentalItem &&
                        <Box>
                            <DataGrid
                                slots={{
                                    toolbar: () => SimpleCustomToolbar(),
                                }}
                                rows={rentalTypeRowData.rows}
                                rowCount={rentalTypeRowData.total_count}
                                columns={rentalType_columns}
                                disableRowSelectionOnClick
                                experimentalFeatures={{ newEditingApi: true }}
                                autoHeight={true}
                                loading={isLoading}
                                pageSizeOptions={[10, 20, 50, 100]}
                                pagination
                                paginationMode="server"
                                paginationModel={paginationModel}
                                onPaginationModelChange={setMyPaginationModel}
                                filterMode={"server"}
                                onRowClick={rentalTypeRowClick}
                                onSortModelChange={(params) => {
                                    if (params[0] !== undefined) {
                                        setRentalTypeSorting(params[0])
                                    } else {
                                        setRentalTypeSorting({ field: 'id', sort: 'asc' })
                                    }
                                }}
                                onFilterModelChange={(params) => { setRentalTypeFiltering(onFilterChange(params)) }}
                            />
                        </Box>
                    }
                    {rentalItemsRowData && selectedRentalItem.id === undefined && !creatingNewRentalItem &&
                        <Box sx={{ p: 1 }}>
                            <LoadingBackdropIndeterminate
                                open={isLoading}
                                text="Loading Rental Items"
                            />
                            {rentalItemsRowData.total_count === 0 && !isLoading &&
                                <Box textAlign={'center'}>
                                    <h1>{selectedLocation.id !== "all" ? "No items at this location" : "No items"}</h1>
                                </Box>
                            }
                            {rentalItemsRowData?.rows.map((item) => (
                                <RentalItemRow
                                    item={item}
                                    editButtonFunction={selectRentalItemEdit}
                                    onClickFunction={selectRentalItem}
                                    showCalendar={true}
                                />
                            ))}
                        </Box>
                    }
                    {(selectedRentalItem.id !== undefined || creatingNewRentalItem) &&
                        <RentalItem
                            id={selectedRentalItem.id}
                            creatingNewRentalItem={creatingNewRentalItem}
                            newRentalItem={selectedRentalItem}
                            newlyCreatedCallback={newlyCreatedCallback}
                            backFunction={backButton}
                            editMode={editingRentalItem}
                        />
                    }
                </Grid>
            </Grid>
        </React.Fragment>)
    );
}
